<div #container class="nc-floating-lines-canvas-container" [style.mix-blend-mode]="ncMixBlendMode"></div>
<div class="nc-content-wrapper">
    <ng-content></ng-content>
</div>